import { Component, OnInit, Input, Renderer2 } from '@angular/core';
import { SharedService } from 'src/app/modules/shared/_services/shared.service';
import { AlertMessageService } from 'src/app/modules/shared/_services/alert-message.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../_services/auth.service';
import { VisitorService } from '../../_services/visitor.service';

interface DataLayerEvent {
  event: string;
  [key: string]: any;
}
declare const dataLayer: DataLayerEvent[];

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {
  @Input() mobileNumber: string = '';
  @Input() openSignup: boolean = false;
  @Input() whatsappConsent: any;

  gstNumber: string = '';
  businessName: string = '';
  email: string = '';
  error: string | null = null;
  verifyData: any = null; // Add this property
  type: 'edit' | 'signup' = 'signup';

  items: { name: string, type: string, isActive: boolean }[] = [];
  selectedStates: string[] = [];
  selectedAuthorities: string[] = [];
  selectedCategories: string[] = [];
  selectedKeywords: string[] = [];
  selectedCities: string[] = [];

  stepTwo = false;
  userId: any
  searchValue: string = '';

  constructor(
    private alertService: AlertMessageService,
    private sharedService: SharedService,
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private renderer: Renderer2, private visitorService: VisitorService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.resolveTenderNewMain();
  }

  resolveTenderNewMain() {
    this.activatedRoute.data.subscribe((rawData: any) => {
      let resolverData: any = rawData['tendersResolver'];
      if (resolverData) {
        const statesList = resolverData?.states?.data?.map((state: any) => ({
          name: state.name,
          type: 'state',
          isActive: false
        })).slice(0, 5);  // Limit to 5 items

        const authorityList = resolverData?.authorities?.data?.map((authority: any) => ({
          name: authority.name,
          type: 'authority',
          isActive: false
        })).slice(0, 5);  // Limit to 5 items

        const categoryList = resolverData?.categories?.data?.map((category: any) => ({
          name: category.name,
          type: 'category',
          isActive: false
        })).slice(0, 5);  // Limit to 5 items

        const keywordsList = resolverData?.keywords?.data?.map((keywords: any) => ({
          name: keywords.name,
          type: 'keywords',
          isActive: false
        })).slice(0, 5);  // Limit to 5 items

        // Combine all items into a single array after slicing
        this.items = [
          ...keywordsList,
          ...categoryList,
          ...statesList,
          ...authorityList,
        ];
      }
    });
  }

  autoPopulateData(verifyData: any): void {
    this.error = null;
    this.verifyData = verifyData; // Assign the verifyData
    this.businessName = verifyData?.businessName || '';
    this.gstNumber = verifyData?.gstNum || '';
    this.type = this.businessName ? 'edit' : 'signup';
  }

  async signUpModal(form: any): Promise<void> {
    if (form.invalid) {
      this.setError('Please fill out all fields correctly.');
      return;
    }
    const visitorId = await this.visitorService.getVisitorId();
    const reqjson = {
      businessName: this.businessName,
      email: this.email,
      gstNum: this.gstNumber,
      phone: this.mobileNumber,
      type: this.type,
      whatsappConsent: this.whatsappConsent,
      guestUserId: visitorId
    };

    this.sharedService.otpSignup(reqjson).subscribe(
      (res: any) => this.handleSuccess(res),
      (error: any) => {
        console.error('Error during OTP signup:', error);  // This should log the full error object now
        this.setError(error?.error?.message || error?.error?.phone || 'An error occurred. Please try again.');
      }
    );
  }

  private handleSuccess(res: any): void {
    if (res?.data?.userId) {
      this.userId = res?.data?.userId;
      const isLoggedIn = this.authService.login(res?.data?.userId, res?.data);
      if (res?.data?.isPreferencesSet) {
        if (isLoggedIn) {
          this.alertService.addSuccess('Successfully logged In').show();
          this.clearBlockingData();
          this.pushNormalUser();
          this.closeModal();
          this.router.navigate([this.router.url]);
        }
      } else {
        this.stepTwo = true;
      }
    }
  }

  setPreferenceFun(): void {
    const requestPayload = {
      authorityPreferences: this.selectedAuthorities,
      categoryPreferences: this.selectedCategories,
      keywordPreferences: this.selectedKeywords,
      statePreferences: this.selectedStates,
      cityPreferences: this.selectedCities,
      userId: this.userId
    };

    this.sharedService.setPreference(requestPayload).subscribe(
      (res: any) => this.handleSuccessPrefrenece(res),
      (error: any) => this.setError(error?.error?.message || error?.error?.phone || 'An error occurred. Please try again.')
    );
  }

  private handleSuccessPrefrenece(res: any): void {
    this.alertService.addSuccess('Signup Successful, Page Will Refresh Once!').show();
    this.closeModal();
  }

  private clearBlockingData(): void {
    if (typeof window !== 'undefined') {
      localStorage.removeItem('Count');
      localStorage.removeItem('isB');
      localStorage.removeItem('StartTime');
    }
  }

  // This method will be triggered by the child component
  onSearchValueSelected(selectedItem: any): void {
    const { searchTag, searchName } = selectedItem;

    // Check if the item already exists in the items array
    const existingItemIndex = this.items.findIndex(item => item.name === searchName && item.type === searchTag.toLowerCase());

    if (existingItemIndex !== -1) {
      // If item exists, make it active
      this.items[existingItemIndex].isActive = true;
    } else {
      // If item doesn't exist, add it to the top of the items array
      this.items.unshift({ name: searchName, type: searchTag.toLowerCase(), isActive: true });
    }

    // Add to the corresponding request array based on the searchTag
    switch (searchTag.toLowerCase()) {
      case 'state':
        this.selectedStates.unshift(searchName);  // Add to the top of selectedStates
        break;
      case 'authority':
        this.selectedAuthorities.unshift(searchName);  // Add to the top of selectedAuthorities
        break;
      case 'category':
        this.selectedCategories.unshift(searchName);  // Add to the top of selectedCategories
        break;
      case 'keywords':
        this.selectedKeywords.unshift(searchName);  // Add to the top of selectedKeywords
        break;
      case 'city':
        this.selectedCities.unshift(searchName);  // Add to the top of selectedCities
        break;
    }
  }


  onToggle(index: number): void {
    const selectedItem = this.items[index];
    selectedItem.isActive = !selectedItem.isActive;

    // Update the respective list based on the type
    if (selectedItem.isActive) {
      if (selectedItem.type === 'state') {
        this.selectedStates.push(selectedItem.name);
      } else if (selectedItem.type === 'authority') {
        this.selectedAuthorities.push(selectedItem.name);
      } else if (selectedItem.type === 'category') {
        this.selectedCategories.push(selectedItem.name);
      } else if (selectedItem.type === 'keywords') {
        this.selectedKeywords.push(selectedItem.name);
      }
    } else {
      if (selectedItem.type === 'state') {
        this.selectedStates = this.selectedStates.filter(name => name !== selectedItem.name);
      } else if (selectedItem.type === 'authority') {
        this.selectedAuthorities = this.selectedAuthorities.filter(name => name !== selectedItem.name);
      } else if (selectedItem.type === 'category') {
        this.selectedCategories = this.selectedCategories.filter(name => name !== selectedItem.name);
      } else if (selectedItem.type === 'keywords') {
        this.selectedKeywords = this.selectedKeywords.filter(name => name !== selectedItem.name);
      }
    }
  }

  private setError(message: string): void {
    this.error = message;
  }

  isValidGstNumber(gstNumber: string): boolean {
    return /^[A-Z0-9]{15}$/.test(gstNumber);
  }

  isValidEmail(email: string): boolean {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  pushNormalUser(): void {
    if (typeof dataLayer !== 'undefined') {
      dataLayer.push({ event: 'sign_up/login' });
    } else {
      console.warn("dataLayer is not defined.");
    }
  }

  closeModal(): void {
    this.openSignup = false;
    this.renderer.removeClass(document.body, 'no-scroll');
  }

}
